import SourceIcon from '@mui/icons-material/Source';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LzCModule from '@lz-modules/Module';

// Create the module and use the customized entities in it
const ContentsModule = new LzCModule({
    ident: 'content',
    name: 'Content',
    icon: <SourceIcon />,
    children: [
        { variation: 'Entity', ident: 'weighing-cards', icon: <AssignmentIcon /> },
    ],
});

export default ContentsModule;
